export default "__VITE_ASSET__DgxnIUNZ__"